import React from 'react';
import {CollapsableCardItemContainer} from "./CollapsableCardItemContainer";

type CollapsableCardBodyItemContainerProps = React.ComponentProps<typeof CollapsableCardItemContainer>

/**
 * Based on the CollapsableCardItemContainer with extra spacing between the items. It's preferred location is to hold
 * label-value pairs in the collapsed body container of the Collapsable Card suite of components
 * @param props All props passed through to the internal CollapsableCardItemContainer to override any settings you want
 * @constructor
 */
const CollapsableCardBodyItemContainer = (props: CollapsableCardBodyItemContainerProps) => {
  return <CollapsableCardItemContainer mb={3} {...props} />
}

export { CollapsableCardBodyItemContainer };